import React, { useState } from 'react';
import styles from "./styles.module.scss";
import { beneficiaryTypeChipStyles } from '../../../../../../views/pages/manage/edpOps/studentDetails/paymentSummary/studentBankDetails/utils';
import EyeIcon from "assets/img/svg/svgComponents/EyeIcon";
import PlusIcon from "assets/img/svg/svgComponents/PlusIcon";
import ChequeBookIcon from "assets/img/svg/svgComponents/ChequeBookIcon";
import {ReactComponent as DeleteIcon} from "assets/img/svg/DeleteRedOutlined.svg";
import PencilIcon from "assets/img/svg/svgComponents/PencilIcon";
import ChequeDetailsFormDialog from './ChequeDetailsFormDialog';
import CustomChip from '../../../../../../views/pages/manage/common/customChip/CustomChip';
import UserIcon from "assets/img/svg/svgComponents/UserIcon";
import BankIcon from "assets/img/svg/svgComponents/BankIcon";
import { EMPTY_CHEQUE_DETAILS_FORM } from '..';

const ChequeDetailsCard = ({
    chequeDetailsForm,
    setChequeDetailsForm = () => {},
    viewOnly,
    bankDropdown,
    highlightCardBorder
}) => {

    const [chequeDetailsFormDialogInfo, setChequeDetailsFormDialogInfo] = useState({isOpen : false, prevChequeDetails : {}});

    const { accountNumber, bankStatus, beneficiaryName, accountType, bankKey, beneficiaryType, chequeDetailsSaved } = chequeDetailsForm;

    const chequeDetailsAvailable = chequeDetailsSaved || viewOnly;


    return (
        <div className={`d-flex flex-column justify-content-between ${styles['bank-details-card']} ${highlightCardBorder ? styles['border-black'] : ''}`}>

            <div className='d-flex justify-content-between'>
                <div className={styles['bank-icon']}><ChequeBookIcon /></div>
                {viewOnly
                    ? <CustomChip text={'Student'} style={beneficiaryTypeChipStyles} />
                    : chequeDetailsSaved && <DeleteIcon className='cursor mt-2' onClick={() => setChequeDetailsForm({ ...EMPTY_CHEQUE_DETAILS_FORM })} />
                }
            </div>

            <div className={styles['account-no']}>{chequeDetailsAvailable ? accountNumber : 'Cheque'}</div>

            <div className='d-flex justify-content-between'>
                <div className={`${styles['bank-details']}`}>
                    {chequeDetailsAvailable
                        ?
                        <>
                            <div>
                                <UserIcon />
                                <span className='ml-1'>{beneficiaryName}  </span>
                                {/* <span>{accountType}</span> */}
                            </div>

                            <div>
                                <BankIcon />
                                <span className='ml-1'>{bankKey} • </span>
                                <span>Cheque</span>
                            </div>
                        </>
                        :
                        <div>Pay through cheque if you have one in hand</div>
                    }
                </div>


                <span
                    className={styles['edit-icon-wrapper'] + " cursor"}
                    onClick={() => setChequeDetailsFormDialogInfo({isOpen : true , prevChequeDetails : chequeDetailsForm})}
                >
                    {
                        viewOnly
                            ? <EyeIcon />
                            : chequeDetailsSaved
                                ? <PencilIcon />
                                : <PlusIcon />
                    }
                </span>

            </div>

            <ChequeDetailsFormDialog
                chequeDetailsForm={chequeDetailsForm}
                setChequeDetailsForm={setChequeDetailsForm}
                viewOnly={viewOnly}
                // isOpen={chequeDetailsFormDialogOpen}
                // closeDialog={() => setChequeDetailsFormDialogOpen(false)}
                dialogInfo={chequeDetailsFormDialogInfo}
                setDialogInfo={setChequeDetailsFormDialogInfo}
                bankDropdown={bankDropdown}
            />


        </div>
    );
}

export default ChequeDetailsCard;